export default {
  namespaced: true,
  share_video_link: {
    title: "compartir enlace de vídeo",
    modal_title: "se requiere contraseña para visualizar el video",
    password: "contraseña",
    password_error: "contraseña incorrecta",
    expired_link: "link de video expirado",
  },
}
